import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

const getIsLoyaltyPrioritySupportNumberEnabled = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => state.loyalty.account,
  (isLoyaltyEnabled, account) => {
    if (!isLoyaltyEnabled) return false
    const accountBenefits = account?.data?.benefits
    return !!accountBenefits?.find((benefit) => benefit.code === 'phone_support')
  },
)

export default getIsLoyaltyPrioritySupportNumberEnabled
